import { BrowserModule } from '@angular/platform-browser';
import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { appRouting } from './app.routes';

import { NwSharedModule } from '@nw/ui-core-shared';

import { MediaDetectorComponent } from './media-detector/media-detector.component';
import { ssoScriptFactory, SsoScriptsService } from '@nw/ui-core-shared/services/sso-scripts.service';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { Http } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { MainStateModule } from './main-state/main-state.module';

import { createTranslateLoader } from '@nw/ui-core-shared';

import { MainStoreService } from '@nw/ui-core-shared/store/main-store.service';
import { UserActions } from '@nw/ui-core-shared/store/actions/user.action';
import { EnvironmentService } from '@nw/ui-core-shared/services/environment.service';
import { environment } from '../environments/environment';

import { Store } from '@ngrx/store';
import { NgxGalleryModule } from 'ngx-gallery';
import {VirtualScrollerModule} from 'ngx-virtual-scroller';

export function createAppTranslateLoader(http: Http) {
  return createTranslateLoader('./assets/ui-core-shared/i18n/', http);
}

class RuntimeEnvironmentService extends EnvironmentService {

  constructor(environment: any = {}) {
    super();
    this.setEnvironment(environment);

    this.retrieveMfeEnvironment()
      .then(env => {
        sessionStorage.setItem(`environment-${window.location.hostname}`, JSON.stringify(env));
      })
      .catch(err => console.error(err));

  }

}

export function environmentServiceProviderFactory() {
  return new RuntimeEnvironmentService(environment);
}

export function getWindow() {
  return window;
}

@NgModule({
  declarations: [
    AppComponent,
    MediaDetectorComponent
  ],
  imports     : [
    MainStateModule,
    NwSharedModule.forRoot({
      mainStateServiceProvider  : MainStoreService,
      environmentServiceProvider: EnvironmentService
    }),
    BrowserModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    JsonpModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide   : TranslateLoader,
        useFactory: createAppTranslateLoader,
        deps      : [Http]
      }
    }),
    appRouting,
    NgxGalleryModule,
    VirtualScrollerModule
  ],
  providers   : [
    {
      provide : MainStoreService,
      useClass: MainStoreService,
      deps    : [Store]
    },
    {provide: 'COM', useValue: {}},
    {provide: 'windowObject', useFactory: getWindow},
    {
      provide   : EnvironmentService,
      useFactory: environmentServiceProviderFactory
    },
    {
      provide   : APP_INITIALIZER,
      useFactory: ssoScriptFactory,
      deps      : [SsoScriptsService, MainStoreService, UserActions, EnvironmentService],
      multi     : true
    }
  ],
  schemas : [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap   : [AppComponent]
})

export class AppModule {

}



// WEBPACK FOOTER //
// ./src/main/angular/app/app.module.ts